// extracted by mini-css-extract-plugin
export default {"page":"DashboardPage_page__+6DZE","rightPanel":"DashboardPage_rightPanel__tdrRT","dashboardWrapper":"DashboardPage_dashboardWrapper__U8kXR"};